import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import TouchableOpacityLink from "../touchable-opacity-link";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";
import { helpers } from "../../utils/helpers";
import ButtonGradient from "../button-gradient";
import { button } from "../../styles/appStyles";

const sliderArrowIcon = getImagePath("icons/slider-arrow-icon.svg");

const SidebarNavSection = ({
  headerData,
  isLoggedIn = false,
  isSubscribedUser = false,
  buttonText = "",
  onSubscribeClick,
}) => {
  const { header_nav, top_nav } = headerData || {};
  const horizontalPadding = helpers.isDesktop() ? 32 : 20;
  const top_nav_modified = [
    ...(top_nav || []),
    ...(!helpers.isDesktop() ? [{ name: "About us", url: "/about-us" }] : []),
  ];

  return (
    <View>
      <View style={{ paddingHorizontal: horizontalPadding }}>
        <Text style={styles.sectionsHeading}>Sections</Text>
        <View style={styles.sectionsList}>
          {header_nav?.length > 0 &&
            header_nav?.map((item) => (
              <View
                key={item.name}
                style={styles.sectionRow}
                onClick={() => (window.location.href = item.url)}
              >
                <Text style={styles.sectionLinkText}>{item.name}</Text>
                <CustomImage
                  source={sliderArrowIcon}
                  require={true}
                  style={{
                    width: 10,
                    height: 10,
                    opacity: 0.5,
                  }}
                  webStyle={{
                    width: 10,
                    height: 10,
                    opacity: 0.5,
                  }}
                  altText={"Slider Arrow"}
                  resizeMode="contain"
                />
              </View>
            ))}
        </View>

        <View
          style={[
            styles.moreContainer,
            { paddingHorizontal: helpers.isDesktop() ? 32 : 16 },
          ]}
        >
          <Text style={styles.moreHeading}>More</Text>
          <View style={styles.moreList}>
            {top_nav_modified?.length > 0 &&
              top_nav_modified?.map((item) => (
                <View key={item.name} style={{ height: 24 }}>
                  <TouchableOpacityLink to={item.url}>
                    <Text style={[styles.moreLinkText]}>{item.name}</Text>
                  </TouchableOpacityLink>
                </View>
              ))}
          </View>
        </View>
      </View>

      <View
        style={[
          styles.actionsContainer,
          {
            paddingHorizontal: horizontalPadding,
            marginTop: helpers.isDesktop() ? 32 : 16,
          },
        ]}
      >
        {!isLoggedIn && (
          <Text
            style={[
              styles.loginButtonText,
              {
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#6c7af6",
                paddingVertical: 12,
              },
            ]}
            onPress={() => (window.location.href = "/sign-in?redirect=/")}
          >
            Login
          </Text>
        )}

        {isSubscribedUser && buttonText ? (
          <View style={{ marginTop: 16 }}>
            <ButtonGradient
              title={`${buttonText}  →`}
              rootStyle={{
                btnWrapper: [button.primaryGradient, { height: 36 }],
                btnText: [
                  button.primaryGradientText,
                  {
                    fontSize: 14,
                    paddingHorizontal: 25,
                    fontWeight: "500",
                    letterSpacing: 0.39,
                    fontFamily: "HaasGrotesk-Medium",
                    textTransform: "uppercase",
                    paddingVertical: 12,
                  },
                ],
              }}
              paddingOverride={true}
              onClick={() => {
                onSubscribeClick();
              }}
              isNewGradiant={true}
            />
          </View>
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  sectionsHeading: {
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
    fontSize: 12,
    color: "#A4A49E",
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  sectionsList: {
    marginTop: 16,
    gap: 24,
  },
  sectionRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    height: 24,
  },
  sectionLink: {
    flex: 1,
  },
  sectionLinkText: {
    color: "#292929",
    fontFamily: "HaasGrotesk-Roman",
    fontWeight: "400",
    fontSize: 14,
    textTransform: "uppercase",
    letterSpacing: 1,
    paddingVertical: 12,
  },
  rightArrow: {
    width: 10,
    height: 10,
  },
  moreContainer: {
    backgroundColor: "#f5faf7",
    paddingVertical: 12,
    marginTop: 16,
  },
  moreHeading: {
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
    fontSize: 12,
    color: "#5aa78f",
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  moreList: {
    marginTop: 16,
    gap: 20,
  },
  moreLinkText: {
    color: "#292929",
    fontFamily: "HaasGrotesk-Roman",
    fontWeight: "400",
    fontSize: 13,
    textTransform: "capitalize",
    letterSpacing: 1,
  },
  actionsContainer: {},
  loginButton: {
    width: "100%",
    paddingVertical: 12,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#6C7AF6",
    alignItems: "center",
    justifyContent: "center",
  },
  loginButtonText: {
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
    fontSize: 14,
    color: "#292929",
    textTransform: "uppercase",
    letterSpacing: 2,
    textAlign: "center",
  },
  subscribeOuter: {
    paddingHorizontal: 10,
    paddingVertical: 12,
    backgroundColor: "#2cb680",
    marginTop: 16,
    position: "relative",
    zIndex: 0,
  },
  subscribeInner: {
    padding: 8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  subscribeText: {
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
    fontSize: 14,
    textTransform: "uppercase",
    color: "#FFFFFF",
    textAlign: "center",
    letterSpacing: 0.7,
  },
});

export default SidebarNavSection;
